module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 25"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "РЎР»РѕР№_2",
      "data-name": "РЎР»РѕР№ 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "РЎР»РѕР№_1-2",
      "data-name": "РЎР»РѕР№ 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M16.77,15.06a1.43,1.43,0,0,0-1.63,1.18,1.47,1.47,0,0,1-2.27,1,1.55,1.55,0,0,0-2,.38,1.51,1.51,0,0,1-2.47-.11,1.53,1.53,0,0,0-2-.53,1.49,1.49,0,0,1-2-.72,2,2,0,0,1-.1-.49,1.39,1.39,0,0,0-1.35-1.24,3.81,3.81,0,0,1-.59-.07,1.28,1.28,0,0,1-.88-1.78,1.28,1.28,0,0,0-.61-1.86A1.26,1.26,0,0,1,.63,8.5,1.23,1.23,0,0,0,1,6.66a1.29,1.29,0,0,1,1-2.07c1-.21,1.31-.64,1.29-1.54S4,1.41,5.12,1.66A1.49,1.49,0,0,0,7,.83,1.5,1.5,0,0,1,9.42.41a1.57,1.57,0,0,0,2.15.08,1.49,1.49,0,0,1,2.3.59c.37.9.84,1.15,1.89,1s1.87.56,1.71,1.57a1.32,1.32,0,0,0,1.09,1.61,1.29,1.29,0,0,1,.77,2.17,1.22,1.22,0,0,0,.14,1.84,1.27,1.27,0,0,1-.42,2.26,1.3,1.3,0,0,0-.78,1.78,1.3,1.3,0,0,1-1,1.7A2.07,2.07,0,0,1,16.77,15.06ZM10,15.73c4,0,7.31-3,7.33-6.62S14.06,2.43,10,2.42s-7.34,3-7.35,6.63S5.94,15.73,10,15.73Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M6.56,25c-.64-1.14-1.25-2.22-1.84-3.3-.11-.21-.23-.25-.48-.2l-3.95.83,3.49-6.81a1.27,1.27,0,0,1,.28.78,1.41,1.41,0,0,0,1.3,1.3,1.75,1.75,0,0,0,.85-.13A1.59,1.59,0,0,1,8.35,18a1.61,1.61,0,0,0,1.43.7Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M19.14,22.43c-1.32-.3-2.62-.59-3.92-.9a.33.33,0,0,0-.44.18c-.57,1-1.17,2-1.75,3l-.18.29c-.37-.75-.72-1.46-1.06-2.18-.63-1.29-1.25-2.58-1.89-3.86-.07-.16-.1-.24.14-.29a1.38,1.38,0,0,0,.8-.5,1.62,1.62,0,0,1,2.19-.4,1.5,1.5,0,0,0,2.27-1,1.51,1.51,0,0,1,.48-.89c.1-.08.17-.11.24,0l3.12,6.47Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M15.26,7.08c0,.1-.12.15-.18.21l-4.57,4.15L8.58,13.22c-.14.14-.23.15-.38,0l-3.35-3c-.11-.1-.1-.16,0-.26.47-.42.95-.85,1.42-1.29.12-.12.19-.1.3,0,.52.48,1.06.95,1.57,1.44.17.16.25.17.44,0,1.58-1.46,3.18-2.9,4.76-4.36.2-.18.29-.16.46,0,.42.41.87.8,1.31,1.2A1.85,1.85,0,0,1,15.26,7.08Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15564dcc","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/reward.vue
// module id = 8eec3b5be55a81662c6c
// module chunks = 89